export function formatDuration(seconds, format) {
  if (seconds === 0) {
    return 'Ready'
  }

  const day = Math.floor(seconds / 86400)
  const hour = Math.floor(((seconds % 3155760000) % 86400) / 3600)
  const minute = Math.floor((((seconds % 3155760000) % 86400) % 3600) / 60)

  const ArrWithData = [day, hour, minute]
  let indexOfMoreThenZeroElem = 0
  for (let i = ArrWithData.length; i > 0; i--) {
    if (ArrWithData[i] > 0) {
      indexOfMoreThenZeroElem = i
      break
    }
  }

  let names
  if (format === 'short') {
    names = ['d', 'h', 'm']
  } else {
    names = [' days', ' h', ' m']
  }

  const resultArr = []
  for (let i = ArrWithData.length; i >= 0; i--) {
    if (i === indexOfMoreThenZeroElem && ArrWithData[i] > 0) {
      if (ArrWithData[i] > 1) {
        resultArr.push(`and ${ArrWithData[i]}${names[i]}`)
      } else {
        resultArr.push(`and ${ArrWithData[i]}${names[i]}`)
      }
    } else if (ArrWithData[i] > 0) {
      if (ArrWithData[i] > 1) {
        resultArr.push(`${ArrWithData[i]}${names[i]},`)
      } else {
        resultArr.push(`${ArrWithData[i]}${names[i]},`)
      }
    }
  }

  const stringWithWrongComma = resultArr.reverse().join(' ')

  if (resultArr.length === 1) {
    return stringWithWrongComma.replace('and ', '')
  } else {
    return stringWithWrongComma.replace(', and', ',')
  }
}
